const SectionTitle = (props) => {
  const {
    titleClass,
    subtitleClass,
    descClass,
    secondDescClass,
    effectClass,
    thirdDescClass,
    secondDescription,
    thidDescription,
  } = props;


  return (
    <div className={props.sectionClass}>
      {subtitleClass
        ? props.subtitle && (
            <div className={props.subtitleClass}>{props.subtitle}</div>
          )
        : ""}
      {titleClass ? <div className={props.titleClass}>{props.title}</div> : ""}
      {descClass ? (
        <div
          className={props.descClass}
          dangerouslySetInnerHTML={{ __html: props.description }}
        />
      ) : (
        ""
      )}
      {secondDescription ? (
        <div
          className={props.descClass}
          dangerouslySetInnerHTML={{ __html: props.secondDescription }}
        />
      ) : (
        ""
      )}
    
      {thidDescription ? (
        <div className={props.descClass}>{props.thidDescription}</div>
      ) : (
        ""
      )}
      {effectClass ? <div className={props.effectClass}></div> : ""}
      {}
    </div>
  );
};
export default SectionTitle;
